export interface IQuestion {   
  id?: number;
  responseTypeId?: number;
  question?: string;
  orderNumber?: number;
  responseType?: string;
  responses?: Array<string>
  questionId?: number;
  questionIdByForm?: number;
  response?: string;
  historicalResponseId?: number;
}

export class Question  implements IQuestion  {
  id?: number;
  responseTypeId?: number;
  question?: string;
  orderNumber?: number;
  responseType?: string;
  responses?: Array<string>
  questionId?: number;
  questionIdByForm?: number;
  response?: string;
  historicalResponseId?: number;
}
